import script from "./OrderView.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrderView.vue?vue&type=script&lang=ts&setup=true"

import "./OrderView.vue?vue&type=style&index=0&id=6bdf41a4&lang=less&scoped=true"

import exportComponent from "/Volumes/未命名/repos/qll-web-work/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bdf41a4"]])

export default __exports__